<template>
  <div class="solution-broadcast">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionBroadcast"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          腾讯优图实验室为短视频拍摄、直播、图像处理工具等互联网产品推出了包含「主播核身+美颜特效」的一整套产品解决方案，既保证了视频直播类产品的安全性和正规性，又保证了该类产品的娱乐性和趣味性。其中，主播核身是基于人脸识别技术的主播身份认证，通过主播的一段自拍视频（或一张自拍照）与另外一张照片（可来源于身份证或事先留存自拍照）之间的1:1人脸验证来确认主播身份，防止主播身份造假。美颜特效模块包含了美容美妆、滤镜、动态贴纸、人脸融合等一系列与美相关的能力，让您的产品在竞争激烈的直播行业拥有差异化竞争优势。
        </div>
      </div>
      <div class="broadcast-img-intro">
        <div class="broadcast-plat-item"
          :class="{'no-margin-right' : ((index + 1) % 3 == 0)}"
          v-for="(item, index) in introAuditing"
          :key="index"
          :style="{backgroundImage: 'url(' + item.imgUrl + ')'}">
          <div class="intro-title">{{item.title}}</div>
          <div class="intro-info">{{item.info}}</div>
        </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionBroadcast"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionBroadcast"></application-scene>
      </div>
    </div>
    <div id="anchor-3" class="items-details client-case">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="client-case-broadcast">
        <div class="case-info">
          <div class="broadcast-title">B站</div>
          <div class="broadcast-content">
            bilibili（B站）现为国内最大的年轻人潮流文化娱乐社区，目前B站活跃用户超过1.5亿，每天视频播放量超过一亿，弹幕总量超过14亿。B站移动端使用优图视频直播解决方案，增强了主播与用户之间互动的娱乐性，提升了产品的竞争力。
          </div>
        </div>
        <div class="case-img"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

const introAuditing = [
  {
    title: '人脸关键点追踪',
    info: '精确定位并追踪面部的关键区域位置，优图对视频做到了90点人脸关键点追踪，定位偏差1.8像素，接近人工水平。',
    imgUrl: require('./img/intro/you_video_pic1.1.jpg')
  }, {
    title: '人脸属性识别',
    info: '识别人的性别、年龄、魅力值、CP值以及对比用户脸部表情与目标形象的表情给出表情相似度评分。',
    imgUrl: require('./img/intro/you_video_pic1.2.jpg')
  }, {
    title: '美容美妆滤镜',
    info: '实时美白/磨皮/改善脸型/美妆，定位准确，效果自然。并搭配丰富的高性能滤镜。',
    imgUrl: require('./img/intro/you_video_pic1.3.jpg')
  }, {
    title: '动态贴纸',
    info: '摇头、点头、张嘴、挑眉毛、眨眼、嘟嘴等动作触发贴纸。支持单人贴纸、多人贴纸和多人不同贴纸。',
    imgUrl: require('./img/intro/you_video_pic1.4.jpg')
  }, {
    title: '脸部变形',
    info: '脸部动作可触发形变，支持单人形变、多人形变和多人不同形变，形变方式支持点、方向和力度。',
    imgUrl: require('./img/intro/you_video_pic1.5.jpg')
  }, {
    title: '人脸融合/换脸',
    info: '将人脸融合到素材中，支持本地照片换脸、同屏换脸和同屏复制脸。',
    imgUrl: require('./img/intro/you_video_pic1.6.jpg')
  }, {
    title: '抠脸',
    info: '实时抠出人脸区域，并可对人脸进行缩放、旋转、位移，然后置入素材指定位置。',
    imgUrl: require('./img/intro/you_video_pic1.7.jpg')
  }, {
    title: '抠背景',
    info: '实时人像与背景分割，画面可实现左右镜像、四格/九格复制/缩放等效果，亦可实现背景大光圈模糊。',
    imgUrl: require('./img/intro/you_video_pic1.8.jpg')
  }, {
    title: '全景粒子',
    info: '基于3D空间，点击触发单粒子。粒子运动轨迹可固定。',
    imgUrl: require('./img/intro/you_video_pic1.9.jpg')
  }
];

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      introAuditing,
      AnchorsItems: ['方案介绍', '方案优势', '应用场景', '客户案例'],
      secondNavFixed: false,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-broadcast {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    &.client-case{
      background-color: rgb(245, 246, 247);
      padding-bottom: 100px;
    }
  }
  .solution-title{
    padding-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro{
    width: 1170px;
    margin: 0 auto;
    .content{
      font-size: 16px;
      color: #212121;
      line-height: 1.8;
      text-align: justify;
      margin-bottom: 26px;
    }
  }
  .broadcast-img-intro{
    width: 1170px;
    margin: 58px auto 0;
    font-size: 0;
    .broadcast-plat-item{
      position: relative;
      vertical-align: top;
      width: 380px;
      height: 410px;
      margin-right: 15px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center 0;
      color: #242526;
      &.no-margin-right{
        margin-right: 0;
      }
      .intro-title {
        font-size: 22px;
        line-height: 1.0;
        margin-top: 238px;
        text-align: center;
      }
      .intro-info {
        font-size: 16px;
        line-height: 1.8;
        text-align: justify;
        color: #212121;
        padding: 20px ;
      }
    }
  }
  .client-case-broadcast{
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0;
    .case-info, .case-img{
      display: inline-block;
      height: 340px;
      width: 585px;
      vertical-align: top;
    }
    .case-img{
      background-image: url('./img/case/you_video_pic5.jpg');
    }
    .case-info {
      padding: 58px 36px;
      background: #ffffff;
      line-height: 40px;
      border: #f0f0f0 1px solid;
      border-right: none;
      .broadcast-title{
        line-height: 40px;
        font-size: 26px;
        padding-left: 100px;
        background-image: url(./img/case/you_video_pic5.1.png);
        background-repeat: no-repeat;
        background-position: 0 center;
      }
      .broadcast-content {
        margin-top: 28px;
        font-size: 16px;
        width: 510px;
        text-align: justify;
        line-height: 1.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionBroadcast.vue